import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "pulse-header" }
const _hoisted_2 = {
  key: 0,
  class: "persona-info"
}
const _hoisted_3 = {
  key: 1,
  class: "topic-info"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SourceTag = _resolveComponent("SourceTag")
  const _component_Icon = _resolveComponent("Icon")
  const _component_TopicTile = _resolveComponent("TopicTile")
  const _component_PulseCategory = _resolveComponent("PulseCategory")
  const _component_Ellipsis = _resolveComponent("Ellipsis")
  const _component_StatusDot = _resolveComponent("StatusDot")
  const _component_Badge = _resolveComponent("Badge")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($options.persona)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_SourceTag, {
            class: "tag",
            size: "2rem",
            logo: $options.parent_logo_url,
            name: $options.parent_name
          }, null, 8 /* PROPS */, ["logo", "name"]),
          _createVNode(_component_Icon, {
            class: "arrow",
            size: "1.6rem",
            icon: "arrow"
          }),
          _createVNode(_component_SourceTag, {
            class: "persona-tag",
            size: "2rem",
            logo: $options.logo_url,
            name: $options.name
          }, null, 8 /* PROPS */, ["logo", "name"])
        ]))
      : ($options.topic)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            ($options.parent_name)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_SourceTag, {
                    class: _normalizeClass(["tag", {'persona-tag': $options.parent_type === 'persona'}]),
                    size: "2rem",
                    logo: $options.parent_logo_url,
                    name: $options.parent_name
                  }, null, 8 /* PROPS */, ["class", "logo", "name"]),
                  _createVNode(_component_Icon, {
                    class: "arrow",
                    size: "1.6rem",
                    icon: "arrow"
                  })
                ], 64 /* STABLE_FRAGMENT */))
              : _createCommentVNode("v-if", true),
            _createVNode(_component_TopicTile, {
              class: "tag topic",
              compact: "",
              size: "1.7rem",
              name: $options.name
            }, null, 8 /* PROPS */, ["name"])
          ]))
        : (_openBlock(), _createBlock(_component_SourceTag, {
            key: 2,
            class: "tag",
            size: "2rem",
            logo: $options.logo_url,
            name: $options.name
          }, null, 8 /* PROPS */, ["logo", "name"])),
    _createVNode(_component_PulseCategory, {
      class: "category",
      type: $options.category,
      label: $options.category_label
    }, null, 8 /* PROPS */, ["type", "label"]),
    ($data.time)
      ? (_openBlock(), _createBlock(_component_Ellipsis, {
          key: 3,
          class: "time",
          text: $data.time
        }, null, 8 /* PROPS */, ["text"]))
      : _createCommentVNode("v-if", true),
    (!$options.seen)
      ? (_openBlock(), _createBlock(_component_StatusDot, { key: 4 }))
      : _createCommentVNode("v-if", true),
    ($options.changed)
      ? (_openBlock(), _createBlock(_component_Badge, {
          key: 5,
          success: "",
          uppercase: "",
          class: "badge"
        }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createTextVNode("updated")
          ])),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true)
  ]))
}